import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../../configs/supabase';
import { Product } from '../../types/Product';
import { DataFetchError } from '../../utils/ErrorClass';

export const useProduct = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState<string>('');
  const itemsPerPage = 100;

  const fetchProducts = useCallback(async (page: number, query: string = '') => {
    const startIdx = (page - 1) * itemsPerPage;
    const endIdx = startIdx + itemsPerPage - 1;

    try {
      const { data, error, count } = await supabase
        .from('product')
        .select('*', { count: 'exact' })
        .ilike('name', `%${query}%`)
        .is('deleted_at', null)
        .order('id', { ascending: true })
        .range(startIdx, endIdx);

      if (error) {
        throw new DataFetchError("データの取得失敗: " + error.message);
      }

      setProducts(data as Product[]);
      setTotalPages(Math.ceil((count ?? 0) / itemsPerPage));
      setError(null);
    } catch (err) {
      if (err instanceof DataFetchError) {
        setError(err.message);
      } else {
        setError('予期せぬエラーが発生しました。');
      }
      console.error(err);
    }
  }, [itemsPerPage]);

  useEffect(() => {
    fetchProducts(page, searchQuery);
  }, [page, searchQuery, fetchProducts]);

  return { products, page, totalPages, setPage, setSearchQuery, error };
};
